// Import necessary modules
import React, { useState } from "react";
import { Row, Col, Input, Button } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.css";
import logo from "../../assets/images/Logo2.PNG";
import facebook from "../../assets/icons/Facebook.PNG";
import X from "../../assets/icons/X.PNG";
import instagram from "../../assets/icons/Instagram.PNG";
import linkedin from "../../assets/icons/LinkedIn.PNG";
import { useLocation } from "react-router-dom";
import OpenSignUpModal, {

} from "../../views/AuthModals/SignIn/openSignIn";
import { useCreateNewsLetterMutation } from "../../redux/services/CreateNewsletterSubscription";
import { toast } from "react-toastify";
import { isValidEmail } from "../../utility/validation";

const Footer = () => {
  const location = useLocation();
  const isReadytoFeastAvailable =
    location.pathname === "/" || location.pathname === "/order";
  const isReadytoFeastAvailablePart2 = location.pathname === "/documents"
  const isReadytoFeastAvailablePart3 = location.pathname === "/about-us";
  
  const currentYear = new Date().getFullYear();

  const [isModalOpen, setModalOpen] = useState(false);
  const [isSignInModalOpen, setIsSignInModalOpen] = useState<boolean>(false);
  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [createNewsLetter, { isLoading }] = useCreateNewsLetterMutation();

  return (
    <>
      <footer className="footer text-light py-5">
        <Row className={isReadytoFeastAvailable ? "row123Adjust" : isReadytoFeastAvailablePart2 ? "row123Adjustpt2" : isReadytoFeastAvailablePart3 ? "row123Adjustpt3" : "row123"}>
          <Col md={3} sm={6} className="mb-4 col123">
            <div className="footer-logo">
              <img src={logo} alt="Curry King" className="mb-3" />
              <p>
                We use only the freshest ingredients & traditional recipes to.
              </p>
              <div className="social-icons d-flex gap-3">
                <a
                  href="https://www.facebook.com/CurryKing.lk"
                  aria-label="Facebook"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={facebook} alt="Facebook" className="facebook" />
                </a>
                <a
                  href="https://x.com/currykinglk"
                  aria-label="Twitter"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={X} alt="Twitter" className="twitter" />
                </a>
                <a
                  href="https://www.instagram.com/curryking.lk?igsh=MTQwYW5lemJ4NHU2bg=="
                  aria-label="Instagram"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={instagram} alt="Instagram" className="instagram" />
                </a>
                <a
                  href="https://www.linkedin.com/company/curry-king-private-limited/"
                  aria-label="LinkedIn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={linkedin} alt="LinkedIn" className="linkedin" />
                </a>
              </div>
            </div>
          </Col>
          <Col md={3} className="mb-4">
            <h5 className="link-title">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-4">
                <a href="/" className="text-light footer-links">
                  Home
                </a>
              </li>
              <li className="mb-4">
                <a href="/order" className="text-light footer-links">
                  Menu
                </a>
              </li>
              <li className="mb-4">
                <a href="/onlineOrders" className="text-light footer-links">
                  Order Online
                </a>
              </li>
              <li className="mb-4">
                <a href="/about-us" className="text-light footer-links">
                  About Us
                </a>
              </li>
              <li className="mb-4">
                <a href="/contact" className="text-light footer-links">
                  Contact
                </a>
              </li>
            </ul>
          </Col>
          <Col md={3} className="mb-4">
            <h5 className="link-title">Information</h5>
            <ul className="list-unstyled">
              <li className="mb-4">
                <a href="careers" className="text-light footer-links">
                  Careers
                </a>
              </li>
              <li className="mb-4">
                <a href="privacy-policy" className="text-light footer-links">
                  Privacy Policy
                </a>
              </li>
              <li className="mb-4">
                <a href="terms-of-service" className="text-light footer-links">
                  Terms of Service
                </a>
              </li>
              <li className="mb-4">
                <a href="terms-of-sale" className="text-light footer-links">
                  Terms of Sale
                </a>
              </li>
              <li className="mb-4">
                <a href="/documents" className="text-light footer-links">
                  Other Policies
                </a>
              </li>
            </ul>
          </Col>
          <Col md={3} className="mb-4">
            <h5 className="link-title">Newsletter</h5>
            <p>
              Join our kingdom to receive the latest news and exclusive offers.
            </p>
            <div className="d-flex align-items-center email-section gap-1 border border-light rounded p-2">
              <Input
                type="email"
                value={newsletterEmail}
                onChange={(e) => setNewsletterEmail(e.target.value)}
                placeholder="✉️ Enter email address"
                className="email-input"
              />
              <Button
                color="warning"
                className="sign-up-btn"
                // onClick={() =>
                //   openModalForSignUpUsers(setModalOpen, setIsSignInModalOpen)
                // }
                disabled={isLoading}
                onClick={async () => {
                  if (!newsletterEmail.trim()) {
                    toast.warning("Please enter a valid email address.");
                    return;
                  }
                  if (!isValidEmail(newsletterEmail)) {
                    toast.warning("Please enter a valid email address.");
                    return;
                  }

                  try {
                    await createNewsLetter({
                      email: newsletterEmail,
                    }).unwrap();
                    toast.success("Subscribed successfully!");
                    setNewsletterEmail("");
                  } catch (error: any) {
                    toast.error("Failed to subscribe. Please try again later.");
                    console.error(error);
                  }
                }}
              >
                Sign&nbsp;Up
              </Button>
            </div>
          </Col>
        </Row>
        <hr />
        <div className="text-center mt-4">
          <p className="mb-0">&copy; {currentYear} Curry King. All Rights Reserved.</p>
        </div>
      </footer>
      <OpenSignUpModal
        toggleModal={toggleModal}
        isModalOpen={isModalOpen}
        isSignInModalOpen={isSignInModalOpen}
        setModalOpen={setModalOpen}
        setIsSignInModalOpen={setIsSignInModalOpen}
      />
    </>
  );
};

export default Footer;
